export class ViewSettings{
	public orderColumn:string = "";
	public orderAscending:boolean = false;
	public limit:number = 20;

	public constructor(data:any){
		this.orderColumn = data.orderColumn;
		this.orderAscending = data.orderAscending;
		this.limit = data.limit;
	}
}